import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]   = useState(null);
  const [role, setRole]   = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const u = localStorage.getItem('ff_user');
    const r = localStorage.getItem('ff_role');
    if (u && r) { setUser(JSON.parse(u)); setRole(r); }
    setReady(true);
  }, []);

  const login = (userData, userRole, tokens) => {
    setUser(userData); setRole(userRole);
    localStorage.setItem('ff_user',    JSON.stringify(userData));
    localStorage.setItem('ff_role',    userRole);
    localStorage.setItem('ff_access',  tokens.access);
    localStorage.setItem('ff_refresh', tokens.refresh);
  };

  const logout = () => {
    setUser(null); setRole(null);
    localStorage.clear();
  };

  return (
    <AuthContext.Provider value={{ user, role, ready, login, logout }}>
      {ready ? children : null}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
